'use strict';

DoohApps.filter('IsArchive', function () {
    return function (fileName) {
        var archiveRegEx = /^.*\.(zip|rar|7z)$/i;
        return archiveRegEx.test(fileName);
    }
})